import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { LINK_CUSTOMER, LINK_CUSTOMER_SUCCESS, LINK_CUSTOMER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* linkCustomer({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // const { clientId, programId, userId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/link-customer`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      }
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: LINK_CUSTOMER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: LINK_CUSTOMER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: LINK_CUSTOMER_ERROR, payload: error });
  }
}

export function* watchLinkCustomer() {
  yield takeEvery(LINK_CUSTOMER, linkCustomer);
}

function* linkCustomerSaga() {
  yield all([fork(watchLinkCustomer)]);
}

export default linkCustomerSaga;
